import { useContext } from 'react';
import { CliDataContext } from '../providers/CliDataProvider';
function useCliDataContext() {
    return useContext(CliDataContext);
}
export default useCliDataContext;
